import { DateTime } from "luxon";

const FULL_FORMAT = "dd MMMM yyyy, hh:mm a";
const SIDEBAR_FORMAT = "dd MMM yyyy, hh:mm a";

export function formatAttemptTimestamp(iso: string | null | undefined): string {
  if (!iso) return "";
  return DateTime.fromISO(iso).toFormat(FULL_FORMAT);
}

export function mapFormAttemptFields(
  attempt: any,
  defaults: { status?: string } = {}
) {
  const status = attempt?.status || defaults.status || "active";
  const completedAtRaw = attempt?.completedAt ?? null;

  return {
    attempt: attempt?.id || "",
    status,
    completedAt: completedAtRaw,
    requiredQuestions: attempt?.requiredQuestions ?? 0,
    requiredAnswered: attempt?.requiredAnswered ?? 0,
    locked: attempt?.isLocked || false,
    lockedBy: attempt?.lockedBy
      ? `${attempt.lockedBy.firstName} ${attempt.lockedBy.lastName}`
      : "",
    lockedAt: attempt?.lockedAt
      ? DateTime.fromISO(attempt.lockedAt).toFormat(FULL_FORMAT)
      : "",
    isSigned: attempt?.isSigned || false,
    signedBy: attempt?.signedBy
      ? `${attempt.signedBy.firstName} ${attempt.signedBy.lastName}`
      : "",
    signedAt: attempt?.signedAt
      ? DateTime.fromISO(attempt.signedAt).toFormat(FULL_FORMAT)
      : "",
  };
}

export function buildPhaseListForm(
  phaseForm: {
    position: number;
    form: { id: string; name: string; status?: string; formAttempts?: any[] };
  },
  phase: { id: string; name: string },
  formAttempt?: any
) {
  const attempt = formAttempt ?? phaseForm.form.formAttempts?.[0];
  return {
    position: phaseForm.position,
    id: phaseForm.form.id,
    name: phaseForm.form.name,
    formStatus: phaseForm.form.status || "",
    phaseName: phase.name,
    phaseId: phase.id,
    ...mapFormAttemptFields(attempt),
  };
}

export function formatFormCompletion(
  status: string,
  completedAt: string | null | undefined,
  variant: "full" | "sidebar" = "full"
): { label: string; display: string | null } {
  if (status === "completed") {
    if (completedAt) {
      const dt = DateTime.fromISO(completedAt);
      const formatted = dt.toFormat(
        variant === "sidebar" ? SIDEBAR_FORMAT : FULL_FORMAT
      );
      return {
        label: variant === "sidebar" ? `Completed ${formatted}` : "Completed on",
        display:
          variant === "sidebar" ? formatted : `Completed on ${formatted}`,
      };
    }
    return { label: "Completed", display: "Completed" };
  }
  return { label: "Not completed", display: null };
}
